//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.component('trackingParamsSwitchReserved', {
    bindings: {
      paramGroupId: '<',
      params: '=',
      allowWarning: '<',
    },
    template: require('@partials/tracking-params/tracking-params-switch-reserved.html'),
    controllerAs: '$reservedCtrl',
    controller: [
      '$scope',
      '$rootScope',
      'TrackingParamsService',
      function(
                $scope,
                $rootScope,
                TrackingParamsService,
            ) {
        const self = this;

        self.hasConfigurePermission = TrackingParamsService.hasConfigurePermission;

                // Get the standard options
        self.reservedParamOptions = TrackingParamsService.getReservedParamDropdownOptions();

                // Remove any options that overlap with the autofill parameter (to handle legacy behavior, there can be multiple)
        const autoFillParameters = _.where(self.params, { autoSet: true });
        const autoFillParameterNames = _.pluck(autoFillParameters, 'name');
        self.reservedParamOptions = _(self.reservedParamOptions).filter(option => autoFillParameterNames.indexOf(option.value) < 0);

        const curalateReservedParameter = _.findWhere(self.params, { curalateReserved: true });
        self.selectedValue = curalateReservedParameter ? curalateReservedParameter.name : self.reservedParamOptions[0].value;
        self.previousSelectedValue = null;
        self.curalateReservedParameterValid = self.selectedValue !== 'none';

        self.changeReservedOption = function(value) {
          if (self.selectedValue !== value) {
            self.previousSelectedValue = self.selectedValue;
            self.selectedValue = value;
            self.curalateReservedParameterValid = self.selectedValue !== 'none';
            $rootScope.$broadcast('trackingParams:changeReservedOption', {
              currentValue: self.selectedValue,
              previousValue: self.previousSelectedValue,
            });
          }
        };

        $scope.$on('trackingParams:changeAutofillOption', (event, data) => {
          self.reservedParamOptions = TrackingParamsService.getReservedParamDropdownOptions();
          self.reservedParamOptions = _(self.reservedParamOptions).filter((option) => {
            return option.value === 'none' || (data.currentValues.indexOf(option.value) < 0);
          });
          _.defer(() => $scope.$apply());
        });

        self.hasCorrectPermissions = function() {
          return self.hasConfigurePermission;
        };
      },
    ],
  });
})();
